import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { formattedNumber } from '../../helpers/String';

import { CellLoader } from './TableLoader';

const FinancialTableFooter = ({ columns, rowData, loading }) => {
  const [totals, setTotals] = useState({});
  const [footerColumns, setFooterColumns] = useState([]);

  useEffect(() => {
    let updatedColumns = [];
    for (let index = 0; index < columns.length; index += 1) {
      if (columns[index].columns && columns[index].columns.length > 0) {
        updatedColumns = updatedColumns.concat(columns[index].columns);
      } else {
        updatedColumns.push(columns[index]);
      }
    }

    setFooterColumns(updatedColumns);
  }, [columns]);

  useEffect(() => {
    if (rowData.length > 0 && !loading) {
      const columnTotals = {};
      Object.keys(rowData).forEach((index) => {
        Object.keys(rowData[index]).forEach((key) => {
          if (key !== 'id' && key !== 'name' && key !== 'status' && key !== 'date_end' && !Number.isNaN(rowData[index][key]) && rowData[index][key]) {
            if (columnTotals[key] === undefined) {
              columnTotals[key] = rowData[index][key];
            } else {
              columnTotals[key] += rowData[index][key];
            }
          }
        });
      });
      setTotals(columnTotals);
    }
  }, [rowData, loading]);

  return (
    <div className="table__row financial-table-footer">
      {footerColumns.map((column, index) => {
        if (loading) {
          return <CellLoader key={`${column.accessor}${Math.random()}`} />;
        }

        return index === 0 ? (
          <div
            key={`${column.accessor}${Math.random()}`}
            className={`table__item table__item--${column.accessor}`}
            style={{ position: 'sticky', zIndex: 3, left: 0 }}
            data-sticky-last-left-td="true"
            data-sticky-td="true"
            role="cell"
          >
            <strong>TOTAL</strong>
          </div>
        ) : (
          <div className="table__item" key={`${column.accessor}${Math.random()}`} role="cell">
            <div style={{ textAlign: 'right' }}>
              <strong>{formattedNumber(totals[column.accessor], '&nbsp;', 0)}</strong>
            </div>
          </div>
        );
      })}
    </div>
  );
};

FinancialTableFooter.defaultProps = {
  columns: [],
  rowData: [],
  loading: false,
};

FinancialTableFooter.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rowData: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
};

export default FinancialTableFooter;
